import './_landing-three-card-module-card.scss';
import component from './landing-three-card-module-card';

export default component;
